import { inject, Injectable } from '@angular/core'
import {
  CreateFilePieceListsResult,
  CreateFilesParamsV2,
  CreateFilesResultV2,
  PlanFileApiClient,
} from '../../../../generated/efp-api'
import { firstValueFrom } from 'rxjs'
import { PlanFileDao } from '../plan-file.dao'
import { CreateFileArticlesParams } from '../../../../generated/efp-api/models'

@Injectable({
  providedIn: 'root',
})
export class PlanFileHttpDao implements PlanFileDao {
  private readonly apiClient = inject(PlanFileApiClient)

  constructor() {}

  public async createPlanFiles(
    planId: number,
    body: CreateFilesParamsV2
  ): Promise<CreateFilesResultV2> {
    return await firstValueFrom(this.apiClient.createPlanFiles({ planId, body }))
  }

  public async createPlanPieceLists(
    planId: number,
    body: CreateFileArticlesParams
  ): Promise<CreateFilePieceListsResult> {
    return await firstValueFrom(this.apiClient.createPlanPieceLists({ planId, body }))
  }
}
